import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";

import { IIcon } from "./icons-interfaces";


const ModelSvg = () => (

	<svg
		width="18px"
		height="18px"
		viewBox="0 0 18 18"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>{"icon/interface/3d"}</title>
		<defs>
			<path
				d="M2.364375,11.389725 C2.77875,11.389725 3.114375,11.725725 3.114375,12.139725 C3.114375,12.485475 2.878875,12.77385 2.5605,12.860475 C3.4605,13.674975 4.970625,14.627475 7.111125,14.627475 C9.499875,14.627475 11.0625,13.605975 11.87475,12.8766 C11.52225,12.815475 11.253375,12.50985 11.253375,12.139725 C11.253375,11.725725 11.589375,11.389725 12.003375,11.389725 L13.618125,11.389725 C14.032125,11.389725 14.368125,11.725725 14.368125,12.139725 L14.368125,13.70685 C14.368125,14.12085 14.032125,14.45685 13.618125,14.45685 C13.293,14.45685 13.0185,14.24835 12.915,13.95885 C11.9325,14.851725 10.021125,16.127475 7.111125,16.127475 C4.39125,16.127475 2.48775,14.826225 1.473375,13.89435 C1.389375,14.217225 1.09875,14.45685 0.75,14.45685 C0.335625,14.45685 0,14.12085 0,13.70685 L0,12.139725 C0,11.725725 0.335625,11.389725 0.75,11.389725 Z M7.33365,0 C7.3944,0 7.4529,0.009375 7.509525,0.02325 C7.525275,0.027 7.5399,0.032625 7.555275,0.0375 C7.600275,0.05175 7.6434,0.06975 7.684275,0.091875 L7.712025,0.103125 L13.01265,3.219 C13.24215,3.353625 13.382775,3.599625 13.382775,3.8655 L13.382775,8.93325 L13.37865,8.963625 C13.37715,9.0075 13.37115,9.050625 13.361775,9.09375 C13.358025,9.111 13.355025,9.1275 13.349775,9.144375 C13.33665,9.189 13.31865,9.2325 13.296525,9.27525 C13.291275,9.28575 13.2879,9.297 13.2819,9.307125 C13.26915,9.330375 13.25415,9.343125 13.2429,9.359625 C13.217775,9.39525 13.1934,9.430875 13.16265,9.462 C13.139025,9.485625 13.112025,9.50325 13.085775,9.523125 C13.063275,9.540375 13.04415,9.561 13.019775,9.575625 L7.718775,12.768375 C7.5999,12.84 7.46565,12.876 7.331775,12.876 C7.1979,12.876 7.06365,12.84 6.944775,12.768375 L1.64415,9.575625 C1.619775,9.561 1.60065,9.540375 1.57815,9.523125 C1.552275,9.50325 1.5249,9.485625 1.501275,9.462 C1.470525,9.430875 1.44615,9.39525 1.421025,9.359625 C1.409775,9.343125 1.394775,9.330375 1.38465,9.31275 L1.37443125,9.29132812 L1.3674,9.27525 C1.345275,9.2325 1.327275,9.189 1.31415,9.144375 C1.3089,9.1275 1.3059,9.111 1.30215,9.09375 C1.292775,9.050625 1.286775,9.0075 1.285275,8.963625 L1.28115,8.93325 L1.28115,3.8655 C1.28115,3.599625 1.421775,3.353625 1.651275,3.219 L6.951525,0.103125 L6.979275,0.0915 C7.019775,0.06975 7.062525,0.052125 7.10715,0.037875 C7.1229,0.033 7.138275,0.027 7.1544,0.02325 C7.210275,0.00975 7.26765,0.00075 7.32765,0.000375 Z M7.331775,6.691875 L3.498525,8.9415 L7.331775,11.250375 L11.165025,8.9415 L7.331775,6.691875 Z M6.581775,2.060625 L2.78115,4.294875 L2.78115,7.623375 L6.581775,5.3925 L6.581775,2.060625 Z M8.081775,2.060625 L8.081775,5.3925 L11.882775,7.623375 L11.882775,4.294875 L8.081775,2.060625 Z"
				id="path-1"
			/>
		</defs>
		<g
			id="3d-model"
			stroke="none"
			strokeWidth={1}
			fill="none"
			fillRule="evenodd"
		>
			<g id="stands_grid_new" transform="translate(-143, -246)">
				<g id="grid" transform="translate(66, 225)">
					<g id="Group-5" transform="translate(76, 0)">
						<g id="Group" transform="translate(0, 20)">
							<g id="icon/interface/3d" transform="translate(1, 1)">
								<g id="color/dark_grey" transform="translate(1.875, 0.7499)">
									<mask id="mask-2" fill="white">
										<use xlinkHref="#path-1" />
									</mask>
									<use id="Mask" fill="#000000" xlinkHref="#path-1" />
									<g mask="url(#mask-2)" fill="#4471FF" id="Fill-1">
										<g transform="translate(-1.875, -0.7498)">
											<polygon points="0 18 18 18 18 0 0 0" />
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

const ModelIcon: FunctionComponent<IIcon> = (): JSX.Element =>
{
	return <Icon component={ModelSvg} />;
};


export default ModelIcon;

